"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavbarContainer = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const common_1 = require("../../common");
const Button_1 = require("../../common/element/Button");
const Colors_1 = require("../../Colors");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const account_1 = require("../base/account");
const popup_1 = require("../base/popup");
const classes_1 = require("../base/classes");
const function_1 = require("../menu/function");
const DSSMY001_1 = require("../DSS/DSSMY001");
/**
 * 네비게이션 바 컨테이너
 * @param menu 메뉴
 * @param setMenu 메뉴 변경 함수
 *
 * @returns 네비게이션 바 컨테이너
 *
 * @example
 * 로고, 메뉴,  마이페이지 버튼이 있는 네비게이션 바 컨테이너
 */
exports.NavbarContainer = react_1.default.memo(({ isFooter = false, isTeacher, setIsHovered, isHovered = false, menu, setMenu, }) => {
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    // list를 classesMenu에 따라 필터링하여 생성
    const list = (0, react_1.useMemo)(() => {
        const filteredList = (0, function_1.getFilterMenuList)(isTeacher, hiddenMenus);
        if (isFooter) {
            return ['home', ...filteredList];
        }
        return filteredList;
    }, [isTeacher, hiddenMenus, isFooter]);
    if (!isFooter && isDesktop) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "navbar-center" },
                react_1.default.createElement(common_1.MenuBar, { className: `menu ${isTablet ? 'tablet' : ''}`, isRow: true, isClickDisabled: false, list: list, value: menu, onItemClick: setMenu, setIsHovered: setIsHovered, isHovered: isHovered, option: {
                        titleIcon: {
                            show: isMobile || isTablet ? true : false,
                            size: 24,
                        },
                    } })),
            react_1.default.createElement("div", { className: "navbar-right" },
                false && !isTeacher && (react_1.default.createElement(Button_1.Button, { className: `btn-my-academy${isHovered ? ' hovered' : ''}`, text: "menu.myAcademy", onClick: () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                        component: DSSMY001_1.DSSMY001,
                        componentProps: {},
                        title: '소속 학원',
                        width: 560,
                        isFit: true,
                    }) })),
                react_1.default.createElement(account_1.MyPageDropDown, { isSidebar: true, iconOnly: true, iconColor: Colors_1.Colors.light_grey }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isFooter && (isMobile || isTablet) && (react_1.default.createElement(common_1.MenuBar, { className: `menu ${isTablet ? 'tablet' : ''}`, isRow: true, isClickDisabled: false, list: list, value: menu, onItemClick: setMenu, setIsHovered: setIsHovered, isHovered: isHovered, option: {
                titleIcon: {
                    show: isMobile || isTablet ? true : false,
                    size: 24,
                },
            } })),
        !isFooter && !isDesktop && (react_1.default.createElement(account_1.MyPageDropDown, { isSidebar: true, iconOnly: true }))));
});
